import { memo, useEffect } from 'react';

import auth from 'app/core/auth';

interface Props {}

// eslint-disable-next-line react/display-name
export default memo((props: Props) => {
  useEffect(() => {
    const fetchData = async () => {
      const mgr = auth.userManager;
      mgr.signinSilentCallback().catch((err) => {
        console.log(err, 'error silent redirect call back');
      });
    };
    fetchData();
  }, []);

  return <></>;
});
